export const app_active_passive_tr = {
  true: 'Aktif',
  false: 'Pasif',
};
